import React from 'react';
import { X, XCircle, AlertTriangle, Info, CheckCircle } from 'lucide-react';

interface ErrorAlertProps {
  message: string;
  title?: string;
  onClose?: () => void;
  severity?: 'error' | 'warning' | 'info' | 'success';
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({ 
  message, 
  title,
  onClose,
  severity = 'error'
}) => {
  if (!message) return null;

  const config = {
    error:   { styles: 'bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-red-800 dark:text-red-200',   Icon: XCircle,       iconClass: 'text-red-600 dark:text-red-400' },
    warning: { styles: 'bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 text-yellow-800 dark:text-yellow-200', Icon: AlertTriangle, iconClass: 'text-yellow-600 dark:text-yellow-400' },
    info:    { styles: 'bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 text-blue-800 dark:text-blue-200',   Icon: Info,          iconClass: 'text-blue-600 dark:text-blue-400' },
    success: { styles: 'bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 text-green-800 dark:text-green-200', Icon: CheckCircle,   iconClass: 'text-green-600 dark:text-green-400' },
  };

  const { styles, Icon, iconClass } = config[severity] ?? config.error;

  return (
    <div className={`rounded-lg p-4 ${styles}`}>
      <div className="flex items-start gap-2">
        <Icon className={`h-5 w-5 flex-shrink-0 mt-0.5 ${iconClass}`} />
        <div className="flex-1">
          {title && (
            <h3 className="text-sm font-medium mb-1">{title}</h3>
          )}
          <p className="text-sm">{message}</p>
        </div>
        {onClose && (
          <button
            className="ml-1 flex-shrink-0 hover:opacity-70"
            onClick={onClose}
            aria-label="Close"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorAlert;